import { ADD_ADMIN_ORDERS, UPDATE_ADMIN_ORDER, DELETE_ADMIN_ORDER } from './actions';

const INITIAL_STATE = [];

const orderReducer = (state = INITIAL_STATE, action) => {
     const { rows = state, count } = state;

     switch (action.type) {
          case ADD_ADMIN_ORDERS: {
               return action.payload;
          }
          case UPDATE_ADMIN_ORDER: {
               const index = rows.findIndex((order) => order.id === action.payload.orderId);
               if (index === -1) {
                    return state;
               }

               const newOrders = [...rows];
               newOrders.splice(index, 1, { ...newOrders[index], ...action.payload.order });

               return { rows: newOrders, count };
          }
          case DELETE_ADMIN_ORDER: {
               const newOrders = rows.filter((order) => order.id !== action.payload);
               return { rows: newOrders, count };
          }
          default:
               return state;
     }
};

export default orderReducer;
